import { useCallback, type Dispatch, type SetStateAction } from 'react';
import type { CvssMetricReason } from '@terra/shared-cvss';
import type { EditableFields } from '@terra/ui-design-system';

export const useFindingCvssReasonsChange = (
  setEditableFields: Dispatch<SetStateAction<EditableFields>>,
) =>
  useCallback(
    ({
      metricReasons,
      explanation,
    }: {
      metricReasons: CvssMetricReason[];
      explanation: string;
    }) =>
      setEditableFields((prev) => {
        if (!prev.cvss) {
          return prev;
        }

        const cvss = { ...prev.cvss, metricReasons, explanation };
        const versionField =
          cvss.version === '4.0'
            ? 'cvss40'
            : cvss.version === '3.1'
              ? 'cvss31'
              : null;

        return {
          ...prev,
          cvss,
          ...(versionField
            ? {
                [versionField]: {
                  ...(prev[versionField] ?? cvss),
                  metricReasons,
                  explanation,
                },
              }
            : {}),
        };
      }),
    [setEditableFields],
  );
